<template>
  <parent>
    <loading-page v-if="gettingCertificate" />
    <div
      v-else
      class="certificates-wrapper h-100"
    >
      <form-wrapper
        full-width
      >
        <template v-slot:body>
          <paper-simple>
            <validation-observer
              ref="certificateRules"
              tag="form"
            >
              <div class="col-md-8 col-xl-6 m-auto">
                <validation-provider
                  #default="{ errors }"
                  name="Certificate Body"
                  rules="required"
                >
                  <input-field
                    name="certificateBody"
                    label="Certificate Body (PEM Format)"
                    label-position="top"
                    :error="errors.length ? errors[0] : null"
                  >

                    <b-form-textarea
                      id="certificateBody"
                      v-model="certificate.certificateBody"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Add certificate private body here..."
                      rows="4"
                    />
                  </input-field>
                </validation-provider>

                <validation-provider
                  #default="{ errors }"
                  name="Certificate Private Key"
                  rules="required"
                >
                  <input-field
                    name="certificatePrivateKey"
                    label="Certificate Private Key"
                    label-position="top"
                    :error="errors.length ? errors[0] : null"
                  >

                    <b-form-textarea
                      id="certificatePrivateKey"
                      v-model="certificate.certificatePrivateKey"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Add certificate private key here..."
                      rows="4"
                    />
                  </input-field>
                </validation-provider>

                <validation-provider
                  #default="{ errors }"
                  name="Certificate Chain"
                  rules="required"
                >
                  <input-field
                    name="certificateChain"
                    label="Certificate Chain"
                    label-position="top"
                    :error="errors.length ? errors[0] : null"
                  >

                    <b-form-textarea
                      id="certificateChain"
                      v-model="certificate.certificateChain"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Add certificate chain here..."
                      rows="4"
                    />
                  </input-field>
                </validation-provider>
              </div>
            </validation-observer>
            <custom-input-radio
              v-model="certificate.scopeId"
              class="col-md-8 col-xl-6 m-auto"
              label="Select scope"
              :options="getObjectOptions(certificateModel.scopeOptions)"
            />
          </paper-simple>

          <paper-simple>
            <div class="my-1">
              <b-form-checkbox
                v-model="certificate.syncOnCdn77"
                switch
              >
                Sync with CDN77
              </b-form-checkbox>
            </div>
          </paper-simple>
        </template>

        <template v-slot:footer>
          <b-button
            variant="bg-white"
            @click="$emit('close')"
          >
            Cancel
          </b-button>
          <button-loading
            variant="bg-primary"
            class="ml-16"
            :spinning="importingCertificate"
            @click="validationCertificatesSettings"
          >Create
          </button-loading>
        </template>

      </form-wrapper>
    </div>
  </parent>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import CustomInputRadio from '@/components/form/CustomInputRadio.vue'
import redirectError from '@/services/redirectError'

export default {
  name: 'CertificatesForm',
  components: {
    ValidationProvider,
    ValidationObserver,
    CustomInputRadio,
  },
  props: {
    row: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      certificate: {
        certificateBody: '',
        certificatePrivateKey: '',
        certificateChain: '',
        scopeId: 0,
        syncOnCdn77: false,
      },
      required,
    }
  },
  computed: {
    importingCertificate() {
      return this.$store.state.cdn.importingCertificate
    },
    certificateModel() {
      return this.$store.state.cdn.certificate
    },
    gettingCertificate() {
      return this.$store.state.cdn.gettingCertificate
    },
  },
  created() {
    this.$store.dispatch('cdn/getCertificate', 0)
      .then(() => { this.certificate.scopeId = this.certificateModel.scopeId })
      .catch(err => redirectError(err, this.$router, this.$route.path))
  },
  methods: {
    validationCertificatesSettings() {
      return new Promise((resolve, reject) => {
        this.$refs.certificateRules.validate().then(success => {
          if (success) {
            this.certificate.certificateBody = this.certificate.certificateBody.replaceAll('\n', '')
            this.certificate.certificatePrivateKey = this.certificate.certificatePrivateKey.replaceAll('\n', '')
            this.certificate.certificateChain = this.certificate.certificateChain.replaceAll('\n', '')
            this.$emit('submit', this.certificate)
            resolve()
          } else {
            reject()
          }
        })
      })
    },
    showInfo() {},
  },
}
</script>
